export default __webpack_public_path__ + "static/register-step2-car-58be38d446a92037a48d248b5e60207b.png";